import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { OrderCategory } from '@royalty/model';

export type InteralStateType = {
	[key: string]: any;
};

export const posEventName = {
	floors: "floors",
	kitchens: "kitchens",
	kitchenItemIsCreated: "kitchenItemIsCreated",
	kitchenItemIsPaid: "kitchenItemIsPaid",
	// tableIsUpdated: "tableIsUpdated",
	// tableIsDeleted: "tableIsDeleted",

	floorActive: "floorActive",
	tableIsCreated: "tableIsCreated",
	tableIsUpdated: "tableIsUpdated",
	tableIsDeleted: "tableIsDeleted",

	ticketItemIsCreated: "ticketItemIsCreated",
	ticketItemIsUpdated: "ticketItemIsUpdated",
	ticketItemIsDeleted: "ticketItemIsDeleted",

	categoryActive: "categoryActive",
	restaurantInfo: "restaurantInfo",
	inView: "inView",
	viewMoreOnListTable: "viewMoreOnListTable",
	enableAddSpecials: "enableAddSpecials",
	enableAddModifiers: "enableAddModifiers",
	itemActive: "itemActive",
	ticketDetail: "ticketDetail",
	itemForTransfer: "itemForTransfer",
	addMenuItem: "addMenuItem",
	addItemSpecial: "addItemSpecial",
	addItemModifier: "addItemModifier",
	filterModifierById: "filterModifierById",
	openMenuMobile: "openMenuMobile",
	openCategoryMobile: "openCategoryMobile",
	onOpenActionForChangeViewTicket: "onOpenActionForChangeViewTicket",
	unAuthorize: "unAuthorize",
	viewKitchenScreen: "viewKitchenScreen",
};

/**
 * POS shared service.
 */
@Injectable()
export class PosSharedService {

	private _categories: OrderCategory[];
	public getCategories(): OrderCategory[] {
		return this._categories;
	}
	public setCategories(value: OrderCategory[]) {
		this._categories = value;
	}

	private _isSpitTable: boolean;
	public getIsSpitTable(): boolean {
		return this._isSpitTable;
	}
	public setIsSpitTable(value: boolean) {
		this._isSpitTable = value;
	}

	private _isMobile: boolean;
	public getIsMobile(): boolean {
		return this._isMobile;
	}
	public setIsMobile(value: boolean) {
		this._isMobile = value;
	}

	private _observableState: InteralStateType = new Array<
		BehaviorSubject<any>
	>();

	getObservable(key: string): Observable<any> {
		if (!this._observableState[key]) {
			this._observableState[key] = new BehaviorSubject<any>(null);
		}
		return this._observableState[key].asObservable();
	}

	setObservable(key: string, data: any) {
		if (!this._observableState[key]) {
			this._observableState[key] = new BehaviorSubject<any>(null);
		}
		this._observableState[key].next(data);
	}

	unsubscribe(key: string) {
		if (this._observableState[key]) {
			this._observableState[key].unsubscribe();
			this._observableState[key] = null;
		}
	}
}
